import React from 'react';

const Breadcrumb = ({ pageTitle, breadcrumbItems, backgroundImage }) => {
  return (
    <section 
      className="inner-banner bg-overlay-black-70 bg-holder" 
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="container">
        <div className="row d-flex justify-content-center">
          <div className="col-md-12">
            <div className="text-center">
              <h1 className="text-white">{pageTitle}</h1>
            </div>
            <div className="d-flex justify-content-center">
              <ol className="breadcrumb mb-0 p-0">
                {breadcrumbItems.map((item, index) => (
                  <li key={index} className="breadcrumb-item">
                    {item.link ? (
                      <a href={item.link}>{item.label}</a>
                    ) : (
                      <span>{item.label}</span>
                    )}
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumb;